<script setup lang="ts">
/**
 * design-system.md -> Components -> Avatar and tile ("brand · postmark") and -> Icons ("The
 * postmark brand mark (a lime circle with three ink wavy lines) is custom."). Copied verbatim from
 * mail-admin-handoff/design/screens/component-sidebar.html, coloured with `signal`/`ink` tokens
 * instead of literal hex. `size` in px, default 28 (the rail wordmark lockup's size).
 */
withDefaults(defineProps<{ size?: number }>(), { size: 28 });
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 28 28" aria-hidden="true">
    <circle cx="14" cy="14" r="13" class="fill-signal" />
    <path
      d="M6.5 10.5c1.6-1.4 3.4-1.4 5 0s3.4 1.4 5 0 3.4-1.4 5 0"
      fill="none"
      class="stroke-ink"
      stroke-width="1.8"
      stroke-linecap="round"
    />
    <path
      d="M6.5 14c1.6-1.4 3.4-1.4 5 0s3.4 1.4 5 0 3.4-1.4 5 0"
      fill="none"
      class="stroke-ink"
      stroke-width="1.8"
      stroke-linecap="round"
    />
    <path
      d="M6.5 17.5c1.6-1.4 3.4-1.4 5 0s3.4 1.4 5 0 3.4-1.4 5 0"
      fill="none"
      class="stroke-ink"
      stroke-width="1.8"
      stroke-linecap="round"
    />
  </svg>
</template>
